"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }
var _definitions = require('../definitions');
var _mergeClassName = require('../../utils/mergeClassName'); var _mergeClassName2 = _interopRequireDefault(_mergeClassName);
var _isBlank = require('../../utils/isBlank');

const settingsSchema = {
  type: 'object',
  fields: [
    { id: 'placeholder', title: '为空时占位文字', type: 'string' }
  ]
} ;

const component = {
  mixins: [_definitions.vueComponentMixin],
  data() {
    return { enums: [] }
  },
  computed: {
    safeValue: {
      get() {
        return JSON.stringify(this.editValue)
      },
      set(val) {
        this.editValue = JSON.parse(val)
      }
    },
    finalClassName() {
      const props = this.$props;
      const settings = props.uiSettings;
      return _mergeClassName2.default.call(void 0, "ds-inputbox", props.ui.className, props.className);
    },
    currValDisplayText() {
      const {editValue, uiSettings} = this;
      const placeholder = _optionalChain([uiSettings, 'optionalAccess', _ => _.placeholder]);
      return _isBlank.isBlank.call(void 0, editValue) && typeof placeholder === 'string' ? placeholder : this.safeValue;
    },
  },
  methods: {
    updateEnums() {
      this.enums = _nullishCoalesce(_optionalChain([this, 'access', _2 => _2.container, 'access', _3 => _3.stub, 'optionalAccess', _4 => _4.getEnums, 'call', _5 => _5()]), () => ( this.schema.enum))
    }
  },
  mounted() {
    this.updateEnums()
  },
  beforeUpdate() {
    this.updateEnums()
  },
};

exports. default = component;
 const selectModule = {
  id: "select",
  settingsSchema,
  component
}; exports.selectModule = selectModule;

;(function(options){
  var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "select",
    {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.safeValue,
          expression: "safeValue"
        }
      ],
      class: _vm.finalClassName,
      style: _vm.ui.style,
      attrs: { id: _vm.inputId, disabled: _vm.readonly },
      on: {
        change: function($event) {
          var $$selectedVal = Array.prototype.filter
            .call($event.target.options, function(o) {
              return o.selected
            })
            .map(function(o) {
              var val = "_value" in o ? o._value : o.value
              return val
            })
          _vm.safeValue = $event.target.multiple
            ? $$selectedVal
            : $$selectedVal[0]
        }
      }
    },
    [
      !_vm.enums.some(function(it) {
        return JSON.stringify(it.value) === _vm.safeValue
      })
        ? _c(
            "option",
            {
              key: "__bad_item__",
              staticClass: "ds-select-invalidOption",
              staticStyle: { display: "none" },
              domProps: { value: _vm.safeValue }
            },
            [_vm._v(_vm._s(_vm.currValDisplayText))]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.enums, function(it, idx) {
        return _c(
          "option",
          { key: idx, domProps: { value: JSON.stringify(it.value) } },
          [_vm._v(_vm._s(it.label || String(it.value)))]
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true


  options.render = render
  options.staticRenderFns = staticRenderFns
  options._compiled = true
})(exports.default);
